import { AutoPostVideoPreferenceOptions } from 'redux/middleware/api/podcast-service';
import {
  facebookPagesSelector,
  instagramAccountsSelector,
  instagramUserNameSelector,
  linkedinOrganizationsSelector,
  linkedinUserNameSelector,
} from 'redux/modules/social';
import { checkIsLinkedinOrganizationProfile } from 'redux/modules/social/linkedin/utils';
import { State } from 'redux/types';

export const createInstagramDisplayNameSelector = (
  autoPostOptions: AutoPostVideoPreferenceOptions,
) => (state: State) => {
  const instagramUserName = instagramUserNameSelector(state);
  const instagramAccounts = instagramAccountsSelector(state);

  const { scopeContext, instagramUserId } = autoPostOptions;

  if (scopeContext === 'instagramBusinessManageV2') {
    return instagramUserName;
  }

  return instagramAccounts.find(
    ({ instagramId }) => instagramId === instagramUserId,
  )?.username;
};

export const createLinkedinDisplayNameSelector = (
  autoPostOptions: AutoPostVideoPreferenceOptions,
) => (state: State) => {
  const linkedinUserName = linkedinUserNameSelector(state);
  const linkedinOrganizations = linkedinOrganizationsSelector(state);

  const { linkedinAuthorId } = autoPostOptions;

  const isOrganizationProfile = checkIsLinkedinOrganizationProfile(
    linkedinAuthorId,
  );

  if (!isOrganizationProfile) {
    return linkedinUserName;
  }

  return linkedinOrganizations.find(({ id }) => id === linkedinAuthorId)?.name;
};

export const createFacebookDisplayNameSelector = (
  autoPostOptions: AutoPostVideoPreferenceOptions,
) => (state: State) => {
  const facebookPages = facebookPagesSelector(state);

  const { facebookPageId } = autoPostOptions;

  return facebookPages.find(({ pageId }) => pageId === facebookPageId)?.name;
};
